// extracted by css-extract-rspack-plugin
export default {"infoIcon":"infoIcon-XPjHKu","content":"content-PAVR6O","body":"body-YJf633","title":"title-NCt2n5"};